import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import produce from 'immer';

import { REPORT_RANGE } from '../../../config/CalendarRangeSet';
import { getExpressParams, postExpress } from '../../../service/api';
import ReportCreateOptionBar from '../../presentation/section/report-create-page/ReportCreateOptionBar';
import ReportCreateResult from '../../presentation/section/report-create-page/ReportCreateResult';
import JSONtoReportData from '../json-to-chartdata/JSONtoReportData';
import LoadingOverlay from 'react-loading-overlay';
import { CHANNEL_ARRAY_ADMIN_SET, CHANNEL_ARRAY_SET, Channel_CODE_SET } from '../../../config/CgmCodeSet';
import { REPORT_TYPE_SET } from '../../../config/ReportOptionSet';
import AlertModal from '../../presentation/modal/AlertModal';

const toQuerySelectList = (queryList, labelList) => {
  let options = [];
  
  queryList.info && queryList.info.forEach((queryItem) => {
    let pushItem = {};
    pushItem.value = queryItem.name;
    pushItem.id = queryItem.queryID;
    pushItem.label = `${queryItem.name} (${queryItem.QUERY_TYPE})`
    if(queryItem.label) {
      pushItem.label = `${pushItem.label} (${(labelList.info.filter(labelItem=>labelItem.labelID == queryItem.label)[0].name)})`
    }
    options.push(pushItem)
  })
  
  return options;
}

// maintain SubQuery
const toMultiQuerySelectList = (selectedQuery, queryList, labelList) => {
  let options = [];
  
  queryList.info && queryList.info.filter((item)=>!selectedQuery.includes(item.queryID) ).forEach((queryItem) => {
    let pushItem = {};
    pushItem.value = queryItem.name;
    pushItem.id = queryItem.queryID;
    pushItem.label = `${queryItem.name} (${queryItem.QUERY_TYPE})`
    if(queryItem.label) {
      pushItem.label = `${pushItem.label} (${(labelList.info.filter(labelItem=>labelItem.labelID == queryItem.label)[0].name)})`
    }
    options.push(pushItem)
  })
  
  return options;
}

// reset SubQuery
// const toMultiQuerySelectList = (mainQuery, queryList, labelList) => {
//   let options = [];
  
//   queryList.info.filter((item)=>item.queryID != mainQuery).forEach((queryItem) => {
//     let pushItem = {};
//     pushItem.value = queryItem.name;
//     pushItem.id = queryItem.queryID;
//     pushItem.label = `${queryItem.name} (${queryItem.QUERY_TYPE})`
//     if(queryItem.label) {
//       pushItem.label = `${pushItem.label} (${(labelList.info.filter(labelItem=>labelItem.labelID == queryItem.label)[0].name)})`
//     }
//     options.push(pushItem)
//   })
  
//   return options;
// }

const ReportCreate = (props) => {
  const [dateRange, setDate] = useState([new Date(), new Date()]);
  const [querySelectOption, setQuerySelectOption] = useState([]);
  const [multiQuerySelectOption, setMultiQuerySelectOption] = useState([]);
  const [queryList, setQueryList] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [mainQuery, setMainQuery] = useState(null);
  const [subQuery, setSubQuery] = useState([]);
  const [subQueryType, setSubQueryType] = useState("compare");
  const [subQueryOptionList, setSubQueryOptionList] = useState([]);
  const [reportType, setReportType] = useState("volume");
  const [reTweet, setReTweet] = useState(true);
  const [options, setOptions] = useState({
    timeunit: 'daily',
    datatype: 'numeric',
    rows: '50',
    words: '200',
    morph: 'all',
    buzzRows: '10'
  })
  const [resultData, setResultData] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [userLabelData, setUserLabelData] = useState([]);
  const [channels, setChannels] = useState(props.currentRole=='ROLE_ADMIN' ? (CHANNEL_ARRAY_ADMIN_SET) : (CHANNEL_ARRAY_SET));
  // const [channels, setChannels] = useState(CHANNEL_ARRAY_SET);

  // const [channels, setChannels] = useState([
  //   {
  //     id: "social",
  //     name: "소셜 미디어",
  //     checked: false,
  //     subCh: [
  //       {
  //         id: "blog0",
  //         name: "블로그",
  //         checked: false
  //       },
  //       {
  //         id: "blog1",
  //         name: "네이버 블로그",
  //         checked: false
  //       },
  //       {
  //         id: "blog2",
  //         name: "다음 블로그",
  //         checked: false
  //       },
  //       {
  //         id: "blog3",
  //         name: "티스토리",
  //         checked: false
  //       },
  //       {
  //         id: "club0",
  //         name: "클럽",
  //         checked: false
  //       },
  //       {
  //         id: "club1",
  //         name: "네이버 카페",
  //         checked: false
  //       },
  //       {
  //         id: "club2",
  //         name: "다음 카페",
  //         checked: false
  //       },
  //       {
  //         id: "board0",
  //         name: "게시판",
  //         checked: false
  //       },
  //       {
  //         id: "prof0",
  //         name: "전문사이트",
  //         checked: false
  //       },
  //       {
  //         id: "kin0",
  //         name: "지식검색",
  //         checked: false
  //       },
  //       {
  //         id: "sns0",
  //         name: "SNS",
  //         checked: false
  //       },
  //       {
  //         id: "twit1",
  //         name: "트위터",
  //         checked: false
  //       },
  //       // {
  //       //   id: "facebook1",
  //       //   name: "페이스북",
  //       //   checked: false
  //       // },
  //       {
  //         id: "insta1",
  //         name: "인스타그램",
  //         checked: false
  //       },
  //       // {
  //       //   id: "youtube",
  //       //   name: "유튜브",
  //       //   checked: false,
  //       // },
  //       {
  //         id: "video0",
  //         name: "동영상",
  //         checked: false
  //       },
  //       {
  //         id: "youtube1",
  //         name: "유튜브",
  //         checked: false
  //       }
  //     ]
  //   },
  //   {
  //     id: "news",
  //     name: "뉴스미디어",
  //     checked: false,
  //     subCh: [
  //       {
  //         id: "pnews0",
  //         name: "포털뉴스",
  //         checked: false
  //       },
  //       {
  //         id: "tnews0",
  //         name: "종합일간지",
  //         checked: false
  //       },
  //       {
  //         id: "inews0",
  //         name: "인터넷 언론",
  //         checked: false
  //       },
  //       {
  //         id: "bnews0",
  //         name: "방송사",
  //         checked: false
  //       },
  //       {
  //         id: "enews0",
  //         name: "경제전문지",
  //         checked: false
  //       },
  //     ]
  //   },
  //   {
  //     id: "shop",
  //     name: "상품평",
  //     checked: false,
  //     subCh: [
  //       {
  //         id: "ashop0",
  //         name: "옥션",
  //         checked: false
  //       },
  //       {
  //         id: "gshop0",
  //         name: "지마켓",
  //         checked: false
  //       },
  //       {
  //         id: "eshop0",
  //         name: "11번가",
  //         checked: false
  //       },
  //       {
  //         id: "cshop0",
  //         name: "쿠팡",
  //         checked: false
  //       },
  //       {
  //         id: "wshop0",
  //         name: "위메프",
  //         checked: false
  //       },
  //       {
  //         id: "tshop0",
  //         name: "티몬",
  //         checked: false
  //       },
  //     ]
  //   },
  //   {
  //     id: "renews",
  //     name: "포털뉴스 댓글",
  //     checked: false,
  //     subCh: []
  //   },
  //   // {
  //   //   id: "youtube",
  //   //   name: "유튜브",
  //   //   checked: false,
  //   //   subCh: []
  //   // },
  // ]);

  const [loaded, setLoaded] = useState(true);
  const [loadingText, setLoadingText] = useState(<div>loading</div>);
  const [onDateBtn, setOnDateBtn] = useState('nope')
  const [userRole, setUserRole] = useState('');

  const [alertShow, setAlertShow] = useState(false);
  const handleAlertShow = () => setAlertShow(true);
  const handleAlertClose = () => setAlertShow(false);

  useEffect(()=>{
    // if(props.currentRole == 'ROLE_ADMIN'){
    //   setChannels(CHANNEL_ARRAY_ADMIN_SET)
    // }else{
    //   setChannels(CHANNEL_ARRAY_SET)
    // }

    getExpressParams('/query/query-label/userid/all', {
      email: props.currentUser
    }, (response)=>{
      setLabelList(response.data.BuzzLabel);
      setQueryList(response.data.queryentity);
      setQuerySelectOption(toQuerySelectList(response.data.queryentity, response.data.BuzzLabel));
      setMultiQuerySelectOption(toQuerySelectList(response.data.queryentity, response.data.BuzzLabel));
    })
    getExpressParams('/users/role/userid', {
      email: props.currentUser
    }, (response) => {
      setUserRole(response.data[0].role)
    })

    getUserLabelData((res)=>setUserLabelData(res));
  }, []);

  useEffect(()=>{
    // initialize subQuery
    // if (!mainQuery){
    //   setSubQuery([])
    //   setMultiQuerySelectOption(toQuerySelectList(queryList, labelList))
      
    // }
    // else{
    //   setSubQuery([]);
    //   setMultiQuerySelectOption(toMultiQuerySelectList([mainQuery], queryList, labelList));
    // }

    //maintain subQuery
    if (!mainQuery){
      setMultiQuerySelectOption(toMultiQuerySelectList([...subQuery], queryList, labelList));
    }
    else{
      setSubQuery(subQuery.filter(item=>item!=mainQuery))
      setMultiQuerySelectOption(toMultiQuerySelectList([mainQuery, ...subQuery], queryList, labelList));
    }
  }, [mainQuery])

  useEffect(() => {
    let tempSubQueryOptionList=[];
    subQuery.forEach((item)=>{
      queryList.info && queryList.info.filter(queryItem=>queryItem.queryID==item).forEach((queryItem) => {
        let pushItem = {};
        pushItem.value = queryItem.name;
        pushItem.id = queryItem.queryID;
        pushItem.label = `${queryItem.name} (${queryItem.QUERY_TYPE})`
        if(queryItem.label) {
          pushItem.label = `${pushItem.label} (${(labelList.info.filter(labelItem=>labelItem.labelID == queryItem.label)[0].name)})`
        }
        tempSubQueryOptionList.push(pushItem)
      })
    })

    // setSubQueryOptionList(
    //   toQuerySelectList(queryList, labelList).filter(item=>subQuery.includes(item.id))
    // );
    setSubQueryOptionList(tempSubQueryOptionList)
    setMultiQuerySelectOption(toMultiQuerySelectList([mainQuery, ...subQuery], queryList, labelList));
  },[subQuery])

  const getUserLabelData = (callback) => {
    getExpressParams('/query/label/userid/all', {
      email: props.currentUser
    }, (response) => {
      callback(response.data.BuzzLabel.info);
    })
  }

  const reportSave = (reportName, labelName, labelID) => {
    
    const selectedChannels = [];
    channels.forEach((ch)=>{
      if (ch.checked) selectedChannels.push(ch.id);
      ch.subCh.forEach((subch)=>{
        if(subch.checked) selectedChannels.push(subch.id)
      })
    })
    postExpress('/query/report-label/userid', {
      "reportName": reportName,
      "labelName": labelName,
      "labelID": labelID,
      "email": props.currentUser,
      "content": {
        "date": [(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "") ,
        (dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "")],
        "reTweet": reTweet,
        "channels": selectedChannels,
        ...options
      },
      "mainQuery": mainQuery,
      "subQuery": subQuery,
      "subQueryType": subQueryType,
      "reportType": reportType,
      // "reTweet": reTweet,
      // "options": options
    },
    (res)=>{
    })
    getUserLabelData((res)=>setUserLabelData(res));
  }

  const setReportJSON = () => {
    let retJSON = {
      dateRange: [(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "") ,
      (dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "")],
      sub_query_type: subQueryType,
      retwit: reTweet,
      reportType: reportType,
      morph: options.morph,
      name: "결과_미리보기"
    }
    const retChannels = [];
    channels.forEach((ch)=>{
      if (ch.checked) retChannels.push(ch.id);
      ch.subCh.forEach((subch)=>{
        if(subch.checked) retChannels.push(subch.id)
      })
    })    
    retJSON.channel = retChannels;

    const retQuery = [];
    let pushItem = queryList.info.find((item)=>item.queryID==mainQuery)
    retQuery.push({
      "name": pushItem.name,
      "type": pushItem.QUERY_TYPE,
      "content": JSON.parse(pushItem.content)
    })

    subQuery.forEach(item=>{
      pushItem = queryList.info.find((query)=>query.queryID==item);
      retQuery.push({
        "name": pushItem.name,
        "type": pushItem.QUERY_TYPE,
        "content": JSON.parse(pushItem.content)
      })
    });
    retJSON.query = retQuery;

    return retJSON
  }

  const handleChannels = (type, id, value) => {
    switch(type) {
      case "channel": {
        setChannels(
          produce(channels, (draft) => {
            const ch = draft.find(item => item.id == id);
            ch.checked = value;
          })
        )
        break;
      }
      case "subChannel" :{
        setChannels(
          produce(channels, (draft) => {
            const ch = draft.find(channel=>channel.subCh.find(item=> item.id==id));
            const subch = ch.subCh.find(item=>item.id==id);
            subch.checked = value;
          })
        )
        break;
      }
      default:
        break;
    }
  } 
  
  const handleRunBtn = () => {
    const retJSON = setReportJSON();
    setResultData(null);

    setLoaded(false);
    handleLoadingText();

    getExpressParams(`/report/${retJSON.reportType}/json`, {
      email: props.currentUser,
      json: retJSON
    }, (response) => {
      if(response.data.success){
        setLoaded(true)
        setLoadingText(<div>loadng</div>)
        setReportData(response.data.report_data);
        setResultData(JSONtoReportData(response.data.report_data, options));
      }
      else{
        setLoaded(true)
        setLoadingText(<div>loadng</div>)
        handleAlertShow();
      }
    })  
  }

  useEffect(()=>{
    if(!resultData){
    }
    else {
      setResultData(JSONtoReportData(reportData, options));
    }
  }, [options.timeunit, options.datatype, options.rows, options.words, options.word_type, options.buzzRows])

  useEffect(()=>{
    if (!resultData) {}
  },[resultData])

  const handleOptions = (type, e) => {
    const option = e.target.getAttribute('name');
    if (type == 'timeunit'){
      setOptions({
        ...options,
        timeunit: option
      })
    }
    else if (type == 'datatype'){
      setOptions({
        ...options,
        datatype: option
      })
    }
    else if (type == 'rows'){
      setOptions({
        ...options,
        rows: option
      })
    }
    else if (type == 'words'){
      setOptions({
        ...options,
        words: option
      })
    }
    else if (type == 'morph'){
      setOptions({
        ...options,
        morph: option
      })
    }
    else if (type == 'word_type'){
      setOptions({
        ...options,
        word_type: option
      })
    }
    else if (type == 'buzzRows') {
      setOptions({
        ...options,
        buzzRows: option
      })
    }
  }

  const handleReTweet = (bool) => {
    setReTweet(bool);
  }

  const handleSubQueryType = (e) => {
    const type = e.target.getAttribute('name');

    setSubQueryType(type);
  }

  const handleDateBtn = (e) => {
    const date = e.target.getAttribute('name');
    let end_date = new Date();
    end_date.setFullYear(end_date.getFullYear(), end_date.getMonth(), end_date.getDate()-1);

    if(props.currentRole=='ROLE_USER_04'){
      let start_date = new Date();
      start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate()-7);
      setDate([start_date, end_date]);
      setOnDateBtn("w1")
      return;
    }

    switch (date) {
      case "1week":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate()-7);
        setDate([start_date, end_date]);
        setOnDateBtn("w1")
        break;
      }
      case "2week":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate()-14);
        setDate([start_date, end_date]);
        setOnDateBtn("w2")
        break;
      }
      case "1month":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth()-1);
        setDate([start_date, end_date]);
        setOnDateBtn("m1")
        break;
      }
      case "3month":{
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth()-3);
        setDate([start_date, end_date]);
        setOnDateBtn("m3")
        break;
      }
      default:
        break;
    }
  }
  const handleReportType = (e) => {
    setReportType(e.target.getAttribute('name'))
    setResultData(null);
    setReportData(null);
  }

  const selectMainQuery = (e) => {
    if (e) {
      setMainQuery(e.id);
    }
    else {  
      setMainQuery(null);
    }
  }

  const selectSubQuery = (e) => {
    if (e) {
      let pushItem = [];
      e.forEach(item=>pushItem.push(item.id))
      setSubQuery(pushItem);
    }
    else {
      setSubQuery([]);
    }
  }

  const handleDate = (selectedDateRange) => {
    setOnDateBtn("nope")
    setDate(selectedDateRange)
  }

  const handleLoadingText = () => {
    let outputBaseQuery = queryList.info.find(item=>item.queryID==mainQuery).name;
    let outputSubQuery = [];
    subQuery.forEach(subQueryItem=>{
      outputSubQuery.push(queryList.info.find(item=>item.queryID==subQueryItem).name)
    });
    let outputChannel = [];
    const retChannels = [];
    channels.forEach((ch)=>{
      if (ch.checked) retChannels.push(ch.id);
      ch.subCh.forEach((subch)=>{
        if(subch.checked) retChannels.push(subch.id)
      })
    })    
    retChannels.forEach(channelItem=>{
      outputChannel.push(Channel_CODE_SET[channelItem])
    })

    setLoadingText(
    <span style={{textAlign: "left"}}>
      <div>
        Date: {(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "-")} ~ {(dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "-")}
      </div>
      <div>
        BaseKeyword: {outputBaseQuery}
      </div>
      {outputSubQuery.length != 0 ?
      <>
        <div>
          SubKeyword: {outputSubQuery.map((item,index)=>{
            if (index==outputSubQuery.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)
          })}
        </div>
        <div>
          SubKeywordType: {subQueryType=="compare"? "비교" : "교차"}
        </div>
      </>
      :undefined}
      <div>
        Channel: {outputChannel.map((item,index)=>{
            if (index==outputChannel.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)        
        })}
      </div>
      <div>
        Report Type: {REPORT_TYPE_SET[reportType]}
      </div>
    </span>
    )
  }

  // After SAVE, get Label Data from server
  return (
    <>
      <AlertModal alertShow={alertShow} handleAlertClose={handleAlertClose} handleAlertShow={handleAlertShow} />
      <LoadingOverlay
        active={!loaded}
        spinner={true}
        text={loadingText}>
        {/* <div className="report-create" style={{display:"flow-root"}}> */}
        <ReportCreateOptionBar dateRange={dateRange} handleDate={handleDate} minDate={REPORT_RANGE(props.currentRole)}
          labelList={labelList} querySelectOption={querySelectOption} selectSubQuery={selectSubQuery} mainQuery={mainQuery} selectMainQuery={selectMainQuery} handleSubQueryType={handleSubQueryType} multiQuerySelectOption={multiQuerySelectOption}
          reportType={reportType} handleReportType={handleReportType} handleDateBtn={handleDateBtn}
          handleOptions={handleOptions} options={options} reTweet={reTweet} handleReTweet={handleReTweet}
          channels={channels} handleChannels={handleChannels}
          handleRunBtn={handleRunBtn} subQueryType={subQueryType}
          userLabelData={userLabelData} handleSaveBtn={reportSave}
          onDateBtn={onDateBtn} currentRole={props.currentRole}
          subQueryOptionList={subQueryOptionList}
          />
        <div className="row featured-main">
          <ReportCreateResult data={resultData} options={options} userRole={userRole} />
        </div>
      </LoadingOverlay>
    </>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole: state.AuthManager.status.currentRole
});
export default connect(mapStateToProps) (ReportCreate);